import {SeoConfig} from './_models'
import seoPages from './seo-pages.json'

interface SeoPageEntry {
  path: string
  title: string
  description: string
  keywords: string | null
  h1: string | null
  content: string | null
  changefreq: string
  priority: string
}

export const SEO_CONFIG: SeoConfig = Object.fromEntries(
  (seoPages as SeoPageEntry[])
    .filter((page) => page.keywords !== null)
    .map((page) => [
      page.path,
      {title: page.title, description: page.description, keywords: page.keywords!},
    ])
)
